import { createIcon } from '@chakra-ui/icons'

const TTFIcon = createIcon({
  viewBox: '0 0 77.9 86.9',
  path: (
    <g transform="translate(5311 -4734.065)">
      <path
        d="M-5242.5 4817.5h-59c-2.5 0-4.5-2-4.5-4.5v-71c0-2.5 2-4.5 4.5-4.5h44.4l19.1 17.3v58.2c0 2.5-2.1 4.5-4.5 4.5z"
        fill="#FFFFFF"
      />
      <path
        d="M-5242.5 4817c2.2 0 4-1.8 4-4v-58l-18.8-17h-44.2c-2.2 0-4 1.8-4 4v71c0 2.2 1.8 4 4 4h59m0 1h-59c-2.8 0-5-2.2-5-5v-71c0-2.8 2.2-5 5-5h44.6l19.4 17.6v58.4c0 2.8-2.3 5-5 5z"
        fill="#E1E4EA"
      />
      <path
        d="M-5237.5 4767h-69v-25c0-2.8 2.2-5 5-5h45.6l18.4 17.5v12.5z"
        fill="#0169BB"
      />
      <path
        d="M-5255.8 4737.1v9.9s-.4 7.4 7.8 7.5 10.4 0 10.4 0l-18.2-17.4z"
        opacity=".6"
        fill="#FFFFFF"
      />
      <text
        transform="translate(-5299.533 4756.032)"
        fontSize="12"
        fontFamily="ArialMT"
        fill="#F7FAFC"
      >
        TTF
      </text>
      <path
        fill="#E1E4EB"
        d="m-5281.7 4777.5-.8.5-3.9 9.3 1.6.7 1.2-2.9h5.2l1.2 2.9 1.6-.7-3.9-9.3-.8-.5h-1.4zm2.6 5.8h-3.8l1.7-4h.4l1.7 4z"
      />
      <path fill="#E1E4EB" d="M-5272.3 4777.5h14.5v1.7h-14.5v-1.7z" />
      <path fill="#E1E4EB" d="M-5285.7 4805.3h28v1.7h-28v-1.7z" />
      <path fill="#E1E4EB" d="M-5285.6 4796h27.8v1.7h-27.8v-1.7z" />
      <path fill="#E1E4EB" d="M-5272.5 4786.8h14.6v1.7h-14.6v-1.7z" />
    </g>
  ),
})

export default TTFIcon
